import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import autobind from 'autobind-decorator'
import { gotoSearchPage } from '../redux/stateUtils'
import { connect } from 'react-redux'
import Select from 'react-select'
import PropTypes from 'prop-types'
import history from '../history'

@autobind
class RoomBookNavTabs extends Component {
  static propTypes = {
    dispatch: PropTypes.func
  }

  componentWillReceiveProps(nextProps) {
    localStorage.removeItem('bookingDetails')
    nextProps.bookingDetails
      ? localStorage.setItem(
          'bookingDetails',
          JSON.stringify(nextProps.bookingDetails)
        )
      : null
    localStorage.removeItem('holdStatus')
    nextProps.holdStatus
      ? localStorage.setItem('holdStatus', JSON.stringify(nextProps.holdStatus))
      : null
  }

  gotoSearchPage(event) {
    gotoSearchPage(event, this.props.location, this.props.dispatch)
  }
  gotoGuestDetailsPage(event) {
    if (event) event.preventDefault()
    var path = this.props.location.pathname
    if (path != '/guestentry' && path != '/results') {
      history.push('/guestentry')
    }
  }
  navigateToMobile(value) {
    if (value === 'search') {
      this.gotoSearchPage()
    } else if (value === 'guestDetails') {
      this.gotoGuestDetailsPage()
    }
  }
  getSelectedOptionsByPage() {
    var path = this.props.location.pathname

    if (path == '/guestentry') {
      return [
        { value: 'search', label: 'Search' },
        { value: 'guestDetails', label: 'Participant Details' }
      ]
    } else if (path == '/payment') {
      return [
        { value: 'search', label: 'Search' },
        { value: 'guestDetails', label: 'Participant Details' },
        { value: 'payment', label: 'Payment' }
      ]
    } else if (path == '/results') return [{ value: 'search', label: 'Search' }]
  }
  getSelectedPage() {
    var path = this.props.location.pathname
    if (path == '/guestentry') return 'Participant Details'
    else if (path == '/payment') return 'Payment'
    else if (path == '/results') return 'search'
  }

  render() {
    let options = this.getSelectedOptionsByPage()
    let getSelectedPage = this.getSelectedPage()
    var path = this.props.location.pathname
    return (
      <Row className='clearfix room-book-nav'>
        <Col md={12}>
          <ul className='propg-tabs'>
            <li className={path == '/results' ? 'active' : ''}>
              <a href='#' onClick={this.gotoSearchPage}>
                Search
              </a>
            </li>
            <li
              className={
                path == '/guestentry'
                  ? 'active'
                  : path == '/results'
                  ? 'disabled'
                  : ''
              }
            >
              {' '}
              <a href='#' onClick={this.gotoGuestDetailsPage}>
                Guest Details
              </a>
            </li>
            <li className={path == '/payment' ? 'active' : 'disabled'}>
              <a href='#'>Payment</a>
            </li>
          </ul>
          <Select
            className='nav-bar-tabs p-0'
            value={getSelectedPage}
            options={options}
            clearable={false}
            disabled={false}
            searchable={false}
            onChange={value => {
              this.navigateToMobile(value)
            }}
            {...this.props}
          />
        </Col>
      </Row>
    )
  }
}

// Which props do we want to inject, given the global state?
function selectProps(state) {
  return {
    history: state.common.history,
    auth: state.common.authentication,
    roomPrices: state.common.roomPrices,
    bookingDetails: state.common.bookingDetails
  }
}

export default connect(selectProps)(RoomBookNavTabs)



// WEBPACK FOOTER //
// ./src/components/roomBookNavTabs.js